import { render } from "./index.vue?vue&type=template&id=5f3f0aee&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=5f3f0aee&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f3f0aee"]])

export default __exports__